const SUBCATEGORY_KEYS = {
    TRANSLATIONS: 'translations',
    PARENT_ID: 'parentId',
    IMAGE: 'img',
    POSITION: 'position',
    ACTIVE: 'active',
    SUBCATEGORIES: 'subcategories',
    CONFIG: 'config',
    HAS_CHANGED: 'hasChanged',
};

export default SUBCATEGORY_KEYS;